import { render, staticRenderFns } from "./CardDetails.vue?vue&type=template&id=05cf376e"
import script from "./CardDetails.vue?vue&type=script&lang=js"
export * from "./CardDetails.vue?vue&type=script&lang=js"
import style0 from "./CardDetails.vue?vue&type=style&index=0&id=05cf376e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports